import { render, staticRenderFns } from "./SocialDataPatientsLaboratory.vue?vue&type=template&id=7400598e&scoped=true"
import script from "./SocialDataPatientsLaboratory.vue?vue&type=script&lang=js"
export * from "./SocialDataPatientsLaboratory.vue?vue&type=script&lang=js"
import style0 from "./SocialDataPatientsLaboratory.vue?vue&type=style&index=0&id=7400598e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7400598e",
  null
  
)

export default component.exports